import { Component, Input } from '@angular/core';
import { AllIconsComponent } from "../../all-icons/all-icons.component";


@Component({
  selector: 'app-modal-delete-list',
  templateUrl: './modal-delete-list.component.html',
  styleUrls: ['./modal-delete-list.component.scss'],
  imports: [
    AllIconsComponent,
  ],
})
export class ModalDeleteListComponent {
  @Input() textList: string[];
  @Input() showIcons = true;
}

